import React from 'react';
import { ArrowDownIcon, CheckIcon, HelpCircleIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { includedItems, planningQuestions, workflowSteps } from '../data/content';
export function System() {
  return <section className="w-full bg-white py-14 sm:py-20" aria-labelledby="system-heading" data-id="element-281" data-mp="15po603tbiu8t">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-282" data-mp="1alv111k6elbz">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-283" data-mp="czpdfyfx0eze">
          This is not just another aligner ebook
        </p>
        <h2 id="system-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-284" data-mp="mx3fgt13d186">
          One workflow, from diagnosis to finishing
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ink-700 sm:text-lg" data-id="element-285" data-mp="1ybpb5bd41vsj">
          The software can show you a treatment plan — but it can’t replace your clinical
          judgment. The System helps you build a repeatable review process around the areas
          that matter most.
        </p>

        <ol className="mx-auto mt-10 w-full max-w-2xl" data-id="element-286" data-mp="hi63pdmqjfwc">
          {workflowSteps.map((step, i) => <li key={step.label} data-id="element-287" data-mp="dgkuq3dbnlrf" data-mpi={i}>
              <div className="flex items-start gap-4 rounded-xl border border-navy-900/10 bg-white p-4 shadow-card sm:p-5" data-id="element-288" data-mp="dfj7z1my1atv">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-navy-900 font-display text-[15px] font-black text-white" data-id="element-289" data-mp="8j2j257x6sfq">
                  {i + 1}
                </span>
                <div className="min-w-0" data-id="element-290" data-mp="3uxc7gebuo0gi">
                  <h3 className="font-display text-[15px] font-extrabold uppercase tracking-[0.08em] text-brand-700 sm:text-base" data-id="element-291" data-mp="3py9dboxerenb">
                    {step.label}
                  </h3>
                  <p className="mt-1 text-[14px] leading-snug text-ink-700 sm:text-[15px]" data-id="element-292" data-mp="3gxb4mtc0yiye">
                    {step.description}
                  </p>
                </div>
              </div>
              {i < workflowSteps.length - 1 ? <div className="flex justify-center py-2" data-id="element-293" data-mp="3bcc2edyc5yxp">
                  <ArrowDownIcon aria-hidden="true" className="h-4 w-4 text-brand-500" data-id="element-294" data-mp="2xbhrnontflvv" />
                </div> : null}
            </li>)}
        </ol>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-295" data-mp="32cowpfykq6yu">
          <div className="rounded-2xl bg-brand-50 p-5 sm:p-6" data-id="element-296" data-mp="3q1847t9sufpv">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-brand-700" data-id="element-297" data-mp="3uz9w93p7dpdh">
              Imagine opening your next case with a plan
            </p>
            <p className="mt-3 text-[15px] font-semibold text-navy-900" data-id="element-298" data-mp="3ga3r6z3op4xo">
              Instead of asking “Does this ClinCheck look right?”, you approach the case with a
              structured sequence of questions:
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-299" data-mp="hkdelfi0irtq">
              {planningQuestions.map(question => <li key={question} className="flex items-start gap-2.5" data-id="element-300" data-mp="22aiq9nmv2mm0">
                  <HelpCircleIcon aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-brand-600" data-id="element-301" data-mp="228o3e3s14kfa" />
                  <span className="text-[13.5px] leading-snug text-navy-900 sm:text-[15px]" data-id="element-302" data-mp="2b1stk6nopx3w">
                    {question}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-navy-950 p-5 sm:p-6" data-id="element-303" data-mp="1jc6hi2zv3eqy">
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-brand-300" data-id="element-304" data-mp="1edlha3km0v2i">
              Everything you get today
            </p>
            <h3 className="mt-2 font-display text-xl font-extrabold text-white sm:text-2xl" data-id="element-305" data-mp="1sai4lv1iruen">
              The Aligner Planning Master System™
            </h3>
            <ul className="mt-5 space-y-2.5" data-id="element-306" data-mp="33qqc8avt5vx6">
              {includedItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-307" data-mp="2yrn4giog1bli">
                  <CheckIcon aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-emerald-400" data-id="element-308" data-mp="3u33cuqqrxbk0" />
                  <span className="text-[13.5px] font-medium leading-snug text-brand-100 sm:text-[15px]" data-id="element-309" data-mp="2wsj7fo3fd2p">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta label="Build my repeatable process" data-id="element-310" data-mp="gwl3ot910x28" />
      </div>
    </section>;
}